<template>
  <div>
    <right-panel-select
      id="transfering-method-panel"
      ref="transferingMethodPanel"
      width="700px"
      :multiple="true"
      store="method"
      :selected="methods"
      @onSelected="transferingMethodSelected"
      @hidden="rightPanelClosed"
    >
      <right-panel class="" id="transfering-method-panel2" width="600px" :text="$t('transfering.method.new')" :icon="'mdi mdi-plus'" @hidden="rightPanelClosed">
        <div class="pl-5 pr-5">
          <WorkspaceMethodForm @onFormSave="onTransferingMethodSaved" />
        </div>
      </right-panel>
    </right-panel-select>

    <right-panel id="transfering-prevention-panel" width="600px" @hidden="rightPanelClosed">
      <div class="pl-5 pr-5">
        <TransferingPreventionPanel @onClosed="onTransferingPreventionSelected" />
      </div>
    </right-panel>

    <right-panel class="float-right" id="transfering-legal-panel" width="1200px" @hidden="rightPanelClosed">
      <div class="pl-5 pr-5">
        <DatasubjectProcessingLegalForm id="transfering-legal-panel" :prepareMode="true" @onSaved="onLegalPrepared" :forTransfering="true" />
      </div>
    </right-panel>

    <h4 class="mb-3">{{ $t("transfering.text") }}</h4>
    <right-panel class="float-right" id="sidebar-new-thirdparty" width="600px" :icon="'mdi mdi-plus'" :text="$t('thirdparty.new')" @hidden="rightPanelClosed">
      <div class="pl-5 pr-5">
        <ThirdPartyForm @onSave="onThirdPartySelect" />
      </div>
    </right-panel>
    <br style="clear:both" />
    <filter-select
      id="thirdPartyFilter"
      ref="thirdPartyFilter"
      :placeholder="$t('thirdparty.text')"
      :max="5"
      :multiple="true"
      @filter="onThirdPartySearch"
      :options="form.thirdparty"
      @changed="onThirdPartySelect"
      :selected="form.thirdParty"
      :validation="true"
      :isValid="!$v.form.thirdParty.$invalid"
    />

    <b-card :header="$t('processing-transfering.reason-and-interest')" header-border-variant="secondary" class="mt-3">
      <b-list-group flush>
        <b-list-group-item class="p-1 hider">
          <b-row>
            <b-col md="3">
              <b> {{ $t("processing-transfering.purpose.text") }}</b>
            </b-col>
            <b-col md="4">
              <b> {{ $t("processing-transfering.legal-reason.text") }}</b>
            </b-col>
            <b-col md="2">
              <b> {{ $t("common.regulation") }}</b>
            </b-col>
            <b-col md="3">
              <b> {{ $t("processing-transfering.legitimate-interest.text") }}</b>
            </b-col>
          </b-row>

          <b-row v-for="i in legals" :key="i._id" class="mt-1">
            <b-col md="3">
              <i class="hand text-danger bx-trash bx hidden" @click="removeLegal(i)"></i>
              {{ i.purpose.name | translate }}
            </b-col>
            <b-col md="4">
              {{ i.legalReason.name | translate }}
            </b-col>
            <b-col md="2">
              {{ i.legalReason.regulation | translate }}
            </b-col>
            <b-col md="3" class="d-flex">
              <i
                v-b-modal="id + i.legalReason.libraryItem._id + i.purpose.libraryItem._id + 'definition-modal-select'"
                @click="selectedLegal = i"
                class="bx bx-search font-size-16 align-middle mt-1 "
              ></i>
              <textarea
                @input="updateLegitimateInterest($event, i)"
                :value="i.legitimateInterest"
                :placeholder="$t('processing-transfering.legitimate-interest.info')"
                class="form-control form-control-sm"
                rows="4"
              ></textarea>

              <ModalSelect
                :id="id + i.legalReason.libraryItem._id + i.purpose.libraryItem._id + 'definition-modal-select'"
                :title="$t('processing-transfering.legitimate-interest.text')"
                store="legitimateInterest"
                @selected="legitimateInterestSelected($event, i)"
              />
            </b-col>
          </b-row>
        </b-list-group-item>

        <empty width="100px" v-if="legals.length == 0">
          <div class="text-center">{{ $t("transfering.no-data") }}</div>
        </empty>

        <b-list-group-item class="p-1 hand text-soft-primary text-right" @click="addLegal"> <i class="bx-plus bx"></i> {{ $t("transfering.add-legal-reason") }}</b-list-group-item>
      </b-list-group>
    </b-card>

    <b-card :header="$t('transfering.method.plural')" header-border-variant="secondary">
      <empty width="100px" v-if="methods.length == 0">
        <div class="text-center">{{ $t("transfering.no-data") }}</div>
      </empty>

      <b-list-group flush>
        <b-list-group-item class="p-1 hider" v-for="i in methods" :key="i._id">
          <i class="hand text-danger bx-trash bx hidden" @click="removeMethod(i)"></i> {{ i.name | translate }}
        </b-list-group-item>
        <b-list-group-item class="p-1 hand text-soft-primary text-right" @click="addMethod"> <i class="bx-plus bx"></i> {{ $t("transfering.add-method") }}</b-list-group-item>
      </b-list-group>
    </b-card>

    <b-card :header="$t('transfering.prevention.plural')" header-border-variant="secondary">
      <empty width="100px" v-if="preventions.length == 0">
        <div class="text-center">{{ $t("transfering.no-data") }}</div>
      </empty>

      <b-list-group flush>
        <b-list-group-item class="p-1 hider" v-for="i in preventions" :key="i._id">
          <i class="hand text-danger bx-trash bx hidden" @click="removePrevention(i)"></i> {{ i.name | translate }}
        </b-list-group-item>
        <b-list-group-item class="p-1 hand text-soft-primary text-right" @click="addPrevention">
          <i class="bx-plus bx"></i> {{ $t("transfering.add-prevention") }}</b-list-group-item
        >
      </b-list-group>
    </b-card>

    <sweet-button @click="save()" :loading="isUpdating" :disabled="isUpdating || $v.$invalid" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
      {{ $t("common.save") }}
    </sweet-button>

    <sweet-button @click="cancel()" variant="secondary" icon="mdi mdi-cancel" size="sm" buttonClass="mt-2 ml-2">
      {{ $t("common.cancel") }}
    </sweet-button>
  </div>
</template>

<script>
import WorkspaceMethodForm from "@modules/transfering/transfering-method/workspace-library-transfering-method-form";
import ModalSelect from "@c/modal-select";
import DatasubjectProcessingLegalForm from "@modules/inventory/component/processing/datasubject-legal-form";
import { required } from "vuelidate/lib/validators";
import ThirdPartyForm from "../../../thirdparty/organization-thirdparty-form";
import TransferingMethodPanel from "./datasubject-transfering-method-panel";
import TransferingPreventionPanel from "./datasubject-transfering-prevention-panel";
import RightPanelSelect from "@c/right-panel-select";
export default {
  props: ["prepareMode", "id"],

  components: { WorkspaceMethodForm, RightPanelSelect, DatasubjectProcessingLegalForm, TransferingMethodPanel, TransferingPreventionPanel, ThirdPartyForm, ModalSelect },
  data() {
    return {
      form: {
        thirdParty: undefined,
      },
      selectedLegal: undefined,
      thirdPartyWatchInitialized: false,
    };
  },
  validations: {
    form: {
      thirdParty: {
        required,
      },
    },
  },
  computed: {
    isUpdating() {
      return this.$store.getters["datasubjectTransfering/isUpdating"];
    },

    methods() {
      return this.$store.getters["datasubjectTransfering/selectedMethods"];
    },
    preventions() {
      return this.$store.getters["datasubjectTransfering/selectedPreventions"];
    },

    legals() {
      return this.$store.getters["datasubjectTransfering/selectedLegals"];
    },

    editedDatasubject() {
      return this.$store.getters["datasubjectTransfering/editedDatasubject"];
    },
    editedDatasubjectTransfering() {
      return this.$store.getters["datasubjectTransfering/editedDatasubjectTransfering"];
    },
  },
  watch: {
    editedDatasubjectTransfering: {
      deep: true,
      immediate: true,
      handler(v) {
        this.form.thirdParty = v?.thirdParty ? [v.thirdParty] : [];
        this.$refs?.thirdPartyFilter?.searchChanged("*");
      },
    },
  },
  mounted() {},
  methods: {
    transferingMethodSelected(items) {
      this.$store.commit("datasubjectTransfering/addMethod", items);
    },

    async save() {
      if (!this.prepareMode) {
        const ok = await this.confirm(this.$t("alert.approve"));
        if (!ok) {
          return;
        }
      }

      try {
        const thirdParties = Array.isArray(this.form.thirdParty) ? this.form.thirdParty : this.form.thirdParty ? [this.form.thirdParty] : [];

        const item = {
          datasubject: this.editedDatasubject,
          thirdParty: thirdParties,
          purposes: this.purposes,
          legals: this.legals.map((i) => ({ ...i, legitimateInterest: i.legitimateInterestLocalized })),
          methods: this.methods,
          preventions: this.preventions,
        };

        if (this.prepareMode) {
          this.$store.commit("gdprInventoryBulkUpdate/removeTransfering", this.editedDatasubjectTransfering);

          this.$emit("onSaved", { ...item });
        } else {
          for (const tp of thirdParties) {
            if (this.editedDatasubjectTransfering) {
              item._id = this.editedDatasubjectTransfering._id;
              await this.$store.dispatch("datasubjectTransfering/update", { item: { ...item, thirdParty: tp } });
            } else {
              await this.$store.dispatch("datasubjectTransfering/create", { item: { ...item, thirdParty: tp } });

              this.$toast.success(this.$t("common.success"));
            }
          }
        }

        this.form = {};
        // this.$refs.thirdPartyFilter.reset(); //bu açık olduğunda, inventoryfilter içinde receiverGroup olması gerektiği gibi temizlenmiyor
        this.$store.commit("datasubjectTransfering/editedDatasubjectTransfering", null);
        this.$store.commit("datasubjectTransfering/editedDatasubject", null);
        this.$root.$emit("bv::toggle::collapse", this.id);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    async onThirdPartySearch(value, callback) {
      const query = { name: { value } };

      if (this.form.thirdParty?.[0]) {
        query.receiverGroup = { value: this.form.thirdParty[0].receiverGroup, isObject: true };
      }

      const response = await this.$store.dispatch(`organizationThirdParty/paginate`, {
        options: { limit: 200 },
        query,
      });

      callback(response.data?.docs ?? []);
    },
    onThirdPartySelect(item) {
      const thirdParties = Array.isArray(item) ? item : item ? [item] : [];
      this.form = { ...this.form, thirdParty: thirdParties };
      // if (item) {
      this.$refs?.thirdPartyFilter?.searchChanged("*");
      //for recommendation
      if (thirdParties.length > 0 || this.thirdPartyWatchInitialized == true) {
        const previousReceiverGroup = this.$store.getters["inventoryFilter/criteria"].receiverGroup;

        this.$store.commit("inventoryFilter/receiverGroup", thirdParties?.[0]?.receiverGroup);
        if (!previousReceiverGroup) {
          this.$store.commit("inventoryFilter/previousReceiverGroup", previousReceiverGroup);
        }
      }
      this.thirdPartyWatchInitialized = true;
      // }
    },

    addMethod() {
      this.$root.$emit("bv::toggle::collapse", "transfering-method-panel");
    },
    removeMethod(item) {
      return this.$store.commit("datasubjectTransfering/removeMethod", item);
    },
    onTransferingMethodSelected(items) {},

    addPrevention() {
      this.$root.$emit("bv::toggle::collapse", "transfering-prevention-panel");
    },
    removePrevention(item) {
      return this.$store.commit("datasubjectTransfering/removePrevention", item);
    },
    onTransferingPreventionSelected(items) {},

    addLegal() {
      this.$root.$emit("bv::toggle::collapse", "transfering-legal-panel");
    },

    onLegalPrepared(items) {
      items.map((i) => {
        const item = { ...i, legitimateInterest: i.legitimateInterest ? i.legitimateInterest[this.currentLanguage] : "" };
        this.$store.commit("datasubjectTransfering/addLegal", item);
      });
    },

    removeLegal(item) {
      return this.$store.commit("datasubjectTransfering/removeLegal", item);
    },
    updateLegitimateInterest($e, legal) {
      const legitimateInterest = $e.target.value;
      legal.legitimateInterest = legitimateInterest;
      legal.legitimateInterestLocalized = {
        tr: legitimateInterest,
        en: legitimateInterest,
        fr: legitimateInterest,
        de: legitimateInterest,
      };
    },

    legitimateInterestSelected(item, legal) {
      if (!item || !this.selectedLegal) {
        return;
      }
      legal.legitimateInterest = item.name[this.currentLanguage];
      legal.legitimateInterestLocalized = item.name;
    },
    rightPanelClosedForm(id) {
      this.$root.$emit("bv::toggle::collapse", id);
    },
    paginateForm(refValue) {
      this.$refs[refValue].reload();
    },

    onTransferingMethodSaved() {
      this.rightPanelClosedForm("transfering-method-panel2");
      this.paginateForm("transferingMethodPanel");
    },

    cancel() {
      this.form = {};
      this.$refs.thirdPartyFilter.reset();
      this.$store.commit("datasubjectTransfering/editedDatasubjectTransfering", null);
      this.$store.commit("datasubjectTransfering/editedDatasubject", null);

      this.$root.$emit("bv::toggle::collapse", this.id);
    },

    rightPanelClosed() {
      this.$store.commit("datasubjectProcessingLegal/showRecommendations", false);
    },
  },
};
</script>
<style scoped>
.card-body {
  padding: 2px !important;
}
.text-soft-primary {
  color: #94a5f8;
}
.card-header {
  color: #8e8e8e;
}
</style>
